export default __webpack_public_path__ + "static/media/nHubanoOpen.6a50fda9.jpg";